<template>
  <div class="">
    
    <!-- 查询表单 -->
    <div>
      <el-form ref="orderAprApplyForm" :model="orderAprApplyForm" label-width="100px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="繁星订单号">
                <el-input v-model="orderAprApplyForm.orderNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-button type="primary" @click="getOrderAprApplyList">查询</el-button>
            <el-button type="primary" @click="addOrderAprApply">添加</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-top: 20px;">
            <!-- 表格 -->
       <el-table
        :data="tableData"
        border
        style="width: 100%">
          <el-table-column
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            prop="source"
            label="来源">
            <template slot-scope="scope">
              <span v-if="scope.row.source === 0">繁星厂家</span>
              <span v-else>繁星KA</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="orderNo"
            label="订单编号">
          </el-table-column>
          <el-table-column
            prop="arguePrice"
            label="追差金额">
          </el-table-column>
          <el-table-column
            prop="price"
            label="完成金额">
            <template slot-scope="scope">
              <span v-if="scope.row.state === 2">{{ scope.row.price }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="moneyWay"
            label="售后打款方式">
            <template slot-scope="scope">
              <span v-if="scope.row.moneyWay === '00'">定期上账</span>
              <span v-else-if="scope.row.moneyWay === '01'">实时打款</span>
              <span v-else></span>
            </template>
          </el-table-column>
          <el-table-column
            prop="rejectReasons"
            label="驳回原因">
            <template slot-scope="scope">
              <span v-if="scope.row.state === -2">{{ scope.row.rejectReasons }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="state"
            label="繁星状态">
            <template slot-scope="scope">
              <span v-if="scope.row.state === 0">待审核</span>
              <span v-else-if="scope.row.state === 1">审核通过</span>
              <span v-else-if="scope.row.state === 2">售后完成</span>
              <span v-else>售后驳回</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="status"
            label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 0">待追差</span>
              <span v-else-if="scope.row.status === 1">追差中</span>
              <span v-else-if="scope.row.status === 2">已撤销</span>
              <span v-else-if="scope.row.status === 3">已完成</span>
              <span v-else-if="scope.row.status === 4">已驳回</span>
              <span v-else>审核通过</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作">
              <template slot-scope="scope">
                <el-button @click="editorOrderAprApply(scope.row)" type="text" size="small">详情</el-button>
                 </template>
          </el-table-column>
      </el-table>
      

      <!-- 分页 -->
      <el-pagination style="margin-top: 20px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotal">
      </el-pagination>
    </div>

    <!-- 修改或新建城市经理对话框 -->
    <el-dialog :title="dlgType === 'change' ? '编辑追差' : '新建追差'" :visible.sync="isDlg" width="700px">
      <div style="margin: 20px;">
        <div>
          <el-form ref="editOrderAprApplyForm" :model="editOrderAprApplyForm" :rules="editorFormRules" label-width="140px">
            <el-form-item label="ID" v-if="dlgType === 'change'">
              <el-input clearable v-model="editOrderAprApplyForm.id" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="订单来源" prop="source">
              <el-radio v-model="editOrderAprApplyForm.source" :label="0">繁星厂家</el-radio>
              <el-radio v-model="editOrderAprApplyForm.source" :label="1">繁星KA</el-radio>
            </el-form-item>
            <el-form-item label="订单编号" prop="orderNo">
              <el-input v-model="editOrderAprApplyForm.orderNo"></el-input>
            </el-form-item>
            <el-form-item label="追差金额" prop="arguePrice">
              <el-input v-model="editOrderAprApplyForm.arguePrice"></el-input>
            </el-form-item>
            <el-form-item label="追差凭证">
              <div>
                  <div
                      v-for="(item, voucherItemIndex) in voucherCombProject"
                      :key="item.id"
                      style="margin-bottom:4px"
                    >
                      <voucher-item
                        :voucher-item-object="item"
                        :item-index="voucherItemIndex"
                        @deleteVoucherItem="deleteVoucherItem"
                      ></voucher-item>
                    </div>
                    <el-button
                      icon="el-icon-circle-plus-outline"
                      @click="addCondition(voucherItemIndex)"
                    ></el-button>
            </div>
            </el-form-item>
            <el-form-item label="追差项">
              <div>
                  <el-row :gutter="10" style="margin-bottom:20px">
                    <el-col :span="16"><span style="color:red">* </span>追差分类</el-col>
                    <el-col  :span="7"><span style="color:red">* </span>追差项</el-col>
                    <el-col  :span="1"></el-col>
                  </el-row>
                  </div>
              <div>
                  <div
                      v-for="(item, apprItemIndex) in aprItemCombProject"
                      :key="item.id"
                      style="margin-bottom:4px"
                    >
                      <apr-item
                        :apr-item-object="item"
                        :item-index="apprItemIndex"
                        @deleteAprItem="deleteAprItem"
                      ></apr-item>
                    </div>
                    <el-button
                      icon="el-icon-circle-plus-outline"
                      @click="addAprCondition(apprItemIndex)"
                    ></el-button>
            </div>  
            </el-form-item>
          </el-form>
        </div>
        <div style="text-align: center;">
          <el-button type="primary" style="margin: 30px 20px;" @click="submitEditor" v-if="editOrderAprApplyForm.status != 1&&editOrderAprApplyForm.status != 3&&editOrderAprApplyForm.status != 5">确定</el-button>
          <el-button @click="pushOrderAprApply(editOrderAprApplyForm.id)" type="text" size="small" v-if="(editOrderAprApplyForm.status === 0 ||editOrderAprApplyForm.status === 4) && dlgType === 'change' ">申请</el-button>
          <el-button @click="cancelOrderAprApply(editOrderAprApplyForm.id)" type="text" size="small" style="color: red;" v-if="editOrderAprApplyForm.status === 1 && dlgType === 'change'">撤销</el-button>
          <el-button style="margin: 10px 20px;" @click="closeEditorDlg">取消</el-button>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  components:{},
  props:{},
  data(){
    return {
      // 查询数据
      orderAprApplyForm: {
        orderNo: null
      },
      apprItemIndex:0,
      voucherItemIndex:0,
      categoryOptions: [],
      voucherCombProject:[{
        url: null,
        fileType: 'image'
      }],
      aprItemCombProject:[{
        catalogName: null,
        itemName: null
      }],

      // 表格数据
      tableTotal: 0,
      tableData: [],
      pageSize: 10,
      currentPage: 1,

      // 新建编辑对话框数据

      isDlg: false,
      editOrderAprApplyForm: {
        id: null,
        type: 1
      },

      editorFormRules: {
        orderNo: [
          { required: true, message: '请输入繁星订单号', trigger: 'change' },
        ],
        arguePrice: [
          { required: true, message: '请输入追差金额', trigger: 'change' },
        ],
      },
      dlgType: 'change',
      queryGradeList:[],
      orderAprApply:{}
    }
  },
  watch:{},
  computed:{},
  methods:{
    deleteVoucherItem(itemIndex){
      let self = this
      this.voucherCombProject.splice(itemIndex,1);
      self.isRefresh = false;
        this.$nextTick(() => {
          self.isRefresh = true;
        });
    },
    addCondition() {
      this.voucherCombProject.push({
        url: null,
        fileType: 'image'
       });
    },
    deleteAprItem(itemIndex){
      let self = this
      this.aprItemCombProject.splice(itemIndex,1);
      self.isRefresh = false;
        this.$nextTick(() => {
          self.isRefresh = true;
        });
    },
    addAprCondition() {
      this.aprItemCombProject.push({
        catalogName: null,
        itemName: null
       });
    },
    // 请求分类列表，提供编辑时选择用
    getSelectOptions(typeKey, optionName, categoryId) {
      let self = this;
      self.$api
        .getClass({
          categoryId: categoryId,
          typeKey: typeKey,
          status: 1,
          page: 1,
          size: 100000,
        })
        .then((res) => {
          if (res.code === 200) {
            self[optionName] = res.data.records;
          }
        });
    },
    deleteAlipyAccount(id){
      let self = this
        self.$confirm('是否删除').then(() => {
           self.$api.deleteAlipyAccount({id:id}).then(res=>{
           if(res.code === 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
             this.getOrderAprApplyList()
          }
      })
      })
   
    },
    // 分页函数
    handleSizeChange(val) {
      this.pageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleCurrentChange(1)
    },

    handleCurrentChange(val) {
      this.currentPage = val
      // 重新请求订单数据
      this.getOrderAprApplyList()
    }, 

    // 获取门店列表
    getOrderAprApplyList() {
      let self  = this;
      self.$api.listSearchOrderAprApply({
        page: self.currentPage,
        size: self.pageSize,
        orderNo: self.orderAprApplyForm.orderNo || null
      }).then(res => {
        self.tableData = res.data.records || []
        self.tableTotal = res.data.total
      })
    },

    // 添加门店
    addOrderAprApply() {
      this.dlgType = 'new'
      this.editOrderAprApplyForm =  {
        id: null,
        type: "1",
        source:0
      }
      this.aprItemCombProject=[{
        catalogName: null,
        itemName: null
       }]
      this.voucherCombProject=[{
        url: null,
        fileType: 'image'
      }]
      this.$nextTick(()=>{
          this.$refs['editOrderAprApplyForm'].clearValidate()
      })
      this.isDlg = true
    },

    // 修改门店
    editorOrderAprApply(row) {
      let self = this;
      self.getOrderAprApply(row.id)
      self.dlgType = 'change'
      this.$nextTick(()=>{
        self.isDlg = true
      })
    },

    // 关闭编辑对话框
    closeEditorDlg() {
      this.isDlg = false
    },

    // 提交编辑（新建或者修改）
    submitEditor() {
      let self = this;
      self.editOrderAprApplyForm.itemList = JSON.stringify(self.aprItemCombProject)
      self.editOrderAprApplyForm.voucherList = JSON.stringify(self.voucherCombProject)
      this.$refs['editOrderAprApplyForm'].validate((valid) => {
        if (valid) {
          if(self.dlgType === 'change') {
            self.$api.updateOrderAprApply(self.editOrderAprApplyForm).then(res => {
              if(res.code === 200) {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                });
                this.getOrderAprApplyList()
                this.closeEditorDlg()
              }
            })
          } else {
            self.$api.addOrderAprApply(self.editOrderAprApplyForm).then(res => {
              if(res.code === 200) {
                this.$message({
                  message: '添加成功',
                  type: 'success'
                });
                this.getOrderAprApplyList()
                this.closeEditorDlg()
              }
            })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
     
    },

        // 开始追差
    getOrderAprApply(id) {
      let self = this
      this.$api.getOrderAprApply(id).then(res => {
        if(res.code === 200) {
            self.editOrderAprApplyForm = res.data
            self.aprItemCombProject = JSON.parse(res.data.itemList)
            if(self.aprItemCombProject==null){
              self.aprItemCombProject=[{
                catalogName: null,
                itemName: null
              }]
            }
            self.voucherCombProject = JSON.parse(res.data.voucherList)
            if(self.voucherCombProject==null){
              self.voucherCombProject=[{
                url: null,
                fileType: 'image'
              }]
            }
        }
      })
    },

    // 开始追差
    pushOrderAprApply(id) {
      let self = this
      this.$api.pushOrderAprApply(id).then(res => {
        if(res.code === 200) {
          this.$message({
            message: '追差申请提交成功',
            type: 'success'
          });
          self.getOrderAprApplyList()
          this.closeEditorDlg()
        }
      })
    },

    // 撤销
    cancelOrderAprApply(id) {
      let self = this
      this.$api.cancelOrderAprApply(id).then(res => {
        if(res.code === 200) {
          this.$message({
            message: '撤销成功',
            type: 'success'
          });
          self.getOrderAprApplyList()
          this.closeEditorDlg()
        }
      })
    },
  },
  created(){
    
  },
  mounted(){
    let self = this;
    self.getOrderAprApplyList();
  }
}
</script>
<style lang="less" scoped>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>